<template>
  <div class="overflow-auto">
    <b-pagination-nav
      v-if="pages"
      :link-gen="linkGen"
      :number-of-pages="pages"
      align="fill"
      use-router
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ArticleNav',
  computed: {
    pages () {
      return this.getArticlePages
    },
    ...mapGetters([
      'getArticlePages'
    ])
  },
  methods: {
    linkGen (pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    }
  }
}
</script>

<style scoped>

</style>
